import { message } from "antd";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { cloudUpdateInfo } from "store/user/user/user.action";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const useActionAccount = () => {
  // -------------------------- VAR -----------------------------
  const [_, setSearchParams] = useSearchParams();
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  const handleOpen = () => {
    setSearchParams({ viewOpenAccount: true });
  };

  const handleClose = (form) => {
    setSearchParams({});
    form?.resetFields();
  };

  const handleUpdateAccountInfo = (form) => {
    form
      ?.validateFields()
      .then((values) => {
        if (!values) return message.error("Không tìm thấy kết quả submit");
        console.log({ values });
        const { displayName, base64 } = values;
        if (!displayName) return message.error("Không được để trống họ tên!");
        setLoading(true);
        dispatch(
          cloudUpdateInfo({ displayName, base64 }, (res) => {
            setLoading(false);
            if (res?.status === 200) {
              message.success("Đã cập nhật thành công");
              handleClose();
            }
            if (res?.status === 500) {
              message.error(res?.data);
            }
          }),
        );
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { handleOpen, handleClose, handleUpdateAccountInfo, loading };
};
export default useActionAccount;
